<template>
  <div class="board-echarts">
    <div class="content1">
      <div class="data">
        <div class="title">
          <div class="line"></div>
          <div class="text">采购数据</div>
          <div class="line"></div>
        </div>
        <div class="list">
          <div class="item">
            <div class="item-date">年度采购金额</div>
            <div class="item-price">
              <span class="price-icon">￥</span>{{ purchaseData.purchaseAmt
              }}<span class="price-icon"> (亿)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">累计采购金额</div>
            <div class="item-price">
              <span class="price-icon">￥</span
              >{{ purchaseData.totalPurchaseAmt
              }}<span class="price-icon"> (亿)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">年度合同金额</div>
            <div class="item-price">
              <span class="price-icon">￥</span>{{ purchaseData.contractAmt
              }}<span class="price-icon"> (亿)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">累计合同金额</div>
            <div class="item-price">
              <span class="price-icon">￥</span
              >{{ purchaseData.totalContractAmt
              }}<span class="price-icon"> (亿)</span>
            </div>
          </div>
        </div>
      </div>
      <div class="border"></div>
      <div class="echarts">
        <div class="title">各品类集采完成情况</div>
        <div
          class=""
          ref="centralizedProcurementId"
          style="width: 350px; height: 310px;"
        ></div>
      </div>
    </div>
    <div class="content2">
      <div class="data">
        <div class="title">
          <div class="line"></div>
          <div class="text">供应数据</div>
          <div class="line"></div>
        </div>
        <div class="list">
          <div class="item">
            <div class="item-date">集团供应商</div>
            <div class="item-price">
              {{ supplyData.groupSupplierNumber
              }}<span class="price-icon"> (家)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">战略供应商</div>
            <div class="item-price">
              {{ supplyData.strategySupplierNumber
              }}<span class="price-icon"> (家)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">红名单</div>
            <div class="item-price">
              {{ supplyData.redSupplierNumber
              }}<span class="price-icon"> (家)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">黑名单</div>
            <div class="item-price">
              {{ supplyData.blackSupplierNumber
              }}<span class="price-icon"> (家)</span>
            </div>
          </div>
        </div>
      </div>
      <div class="border"></div>
      <div class="echarts">
        <div class="title">各品类结算情况</div>
        <div
          class=""
          ref="typesSettlementId"
          style="width: 350px; height: 310px;"
        ></div>
      </div>
    </div>
    <div class="content3">
      <div class="data">
        <div class="title">
          <div class="line"></div>
          <div class="text">循环数据</div>
          <div class="line"></div>
        </div>
        <div class="list">
          <div class="item">
            <div class="item-date">成交个数</div>
            <div class="item-price">
              {{ loopData.value }}<span class="price-icon"> (个)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">溢价金额</div>
            <div class="item-price">
              <span class="price-icon">￥</span>{{ loopData.premiumAmount
              }}<span class="price-icon"> (万元)</span>
            </div>
          </div>
          <div class="item">
            <div class="item-date">溢价率</div>
            <div class="item-price">{{ loopData.premiumRate }}%</div>
          </div>
          <div class="item">
            <div class="item-date">流拍个数</div>
            <div class="item-price">
              {{ loopData.unsoldNumber }}<span class="price-icon"> (个)</span>
            </div>
          </div>
        </div>
      </div>
      <div class="border"></div>
      <div class="echarts">
        <div class="title">月度处置金额</div>
        <div
          class=""
          ref="monthlyDisposalAmountId"
          style="width: 350px; height: 310px;"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import {
  queryTop4Amt,
  queryMatJcConcPrice,
  queryTop4Count,
  queryCategorySettlementData,
  queryAmountCensus,
  getCycleMonthlyPrice
} from "@/app/shop/api/shopping";
export default {
  name: "boardecharts",
  components: {},
  data() {
    return {
      purchaseData: {},
      purchaseConc: [],
      supplyData: {},
      supplyConc: [],
      loopData: {},
      loopConc: [],
      yearStr: new Date().getFullYear()
    };
  },
  created() {
    this.init();
  },
  mounted() {
    this.init();
  },
  activated() {
    this.init();
  },
  methods: {
    init() {
      queryTop4Amt({}).then(res => {
        if (res.data.code == "0") {
          let obj = res.data.data;
          for (let key in obj) {
            if (key.indexOf(this.yearStr.toString()) !== -1) {
              this.purchaseData = obj[key];
            }
          }
        }
      });

      queryMatJcConcPrice({}).then(res => {
        if (res.data.code == "0") {
          this.purchaseConc = res.data.data;
          // 总金额
          let concPriceData = [];
          // 集采合同金额
          let concJcPriceData = [];
          // 集采率
          let concreatData = [];
          for (let key in this.purchaseConc) {
            concJcPriceData.push(this.purchaseConc[key].concJcPrice);
            concPriceData.push(this.purchaseConc[key].concPrice);
            concreatData.push(this.purchaseConc[key].concReat);
          }
          this.getCentralizedProcurement(
            concJcPriceData,
            concPriceData,
            concreatData
          );
        }
      });
      queryTop4Count({}).then(res => {
        if (res.data.code == "0") {
          this.supplyData = res.data.data[0];
        }
      });

      queryCategorySettlementData({}).then(res => {
        if (res.data.code == "0") {
          this.supplyConc = res.data.data;
          this.supplyConc = this.supplyConc.map(item => {
            return {
              value: Number(item.value),
              name: item.name
            };
          });
          console.log(this.supplyConc, "supplyConc");
          this.getTypesSettlement(this.supplyConc);
        }
      });
      queryAmountCensus({}).then(res => {
        if (res.data.code == "0") {
          this.loopData = res.data.data[0];
        }
      });

      getCycleMonthlyPrice({}).then(res => {
        if (res.data.code == "0") {
          const currentM = new Date().getMonth() - 1;
          const preYearData = new Array(12).fill(null).fill(0, currentM + 1);
          const currentYearData = new Array(12)
            .fill(null)
            .fill(0, 0, currentM + 1);
          res.data.data.forEach(item => {
            if (item.year === Number(this.yearStr)) {
              currentYearData[item.month - 1] = item.price;
            } else {
              preYearData[item.month - 1] = item.price;
            }
          });

          let loopConc = {
            [this.yearStr - 1]: preYearData,
            [this.yearStr]: currentYearData
          };
          console.log(loopConc, "obj");
          this.getMonthlyDisposalAmount(loopConc);
        }
      });
    },
    getCentralizedProcurement(concJcPrice, concPrice, concreat) {
      let concJcPriceMax = Math.max.apply(null, concJcPrice),
        concPriceMax = Math.max.apply(null, concPrice),
        concreatMax = Math.max.apply(null, concreat);
      let maxValue =
        Math.ceil(Math.max(concJcPriceMax, concPriceMax, concreatMax) / 100) *
        100;
      maxValue = maxValue > 0 ? maxValue : 100;
      let interval = maxValue / 5;
      console.log(maxValue, "maxValue");
      const myChart = echarts.init(this.$refs.centralizedProcurementId);
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            console.log(params, "params");
            let result = "";
            params.forEach(function(item, index) {
              const seriesName =
                index != 2 ? item.seriesName + "（万元）" : item.seriesName; // 系列名称
              const value = item.value; // 数据值
              // 按照你想要的格式拼接字符串
              result += `${seriesName}: ${value}<br/>`;
            });
            return result;
          }
        },
        toolbox: {
          feature: {
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ["line", "bar"] },
            restore: { show: false },
            saveAsImage: { show: false }
          }
        },
        grid: {
          left: "15%"
        },
        legend: {
          data: ["集采合同金额", "总计金额", "集采率"]
        },
        xAxis: [
          {
            type: "category",
            data: ["沥青", "燃油", "钢材", "水泥"],
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              color: "#4A4A4A"
            },
            axisLine: {
              lineStyle: {
                color: "#DFDFDF"
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "",
            // min: Math.floor(res.data.data.minDataValue / 50) * 50,
            // max: Math.ceil(Math.max.apply(null, arr) / 50) * 50,
            min: 0,
            max: maxValue,
            interval: interval,
            axisLabel: {
              formatter: "{value}"
            },
            splitLine: {
              lineStyle: {
                type: "dashed" // 设置为虚线
              }
            },
            axisLine: {
              show: false // 这里设置为false隐藏y轴轴线
            },
            axisTick: {
              show: false // 确保这里是 true
            }
          },
          {
            type: "value",
            name: "",
            min: 0,
            max: maxValue < 20 ? 100 : Math.ceil(maxValue / 20) * 20,
            interval: maxValue / 5,
            axisLabel: {
              formatter: "{value}",
              show: false
            },
            splitLine: {
              lineStyle: {
                type: "dashed" // 设置为虚线
              }
            },
            axisLine: {
              show: false // 这里设置为false隐藏y轴轴线
            },
            axisTick: {
              show: false // 确保这里是 true
            }
          }
        ],
        series: [
          {
            name: "集采合同金额",
            type: "bar",
            itemStyle: {
              color: "#347fff"
            },
            tooltip: {
              valueFormatter: function(value) {
                return value;
              }
            },
            // data: [
            //   2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
            // ]
            data: concJcPrice
          },
          {
            name: "总计金额",
            type: "bar",
            itemStyle: {
              color: "#ff7f17"
            },
            tooltip: {
              valueFormatter: function(value) {
                return value;
              }
            },
            // data: [
            // 382.6, 5.9, 9.0, 26.4]
            data: concPrice
          },
          {
            name: "集采率",
            type: "line",
            yAxisIndex: 1,
            symbol: "none",
            itemStyle: {
              color: "#38b92b"
            },
            tooltip: {
              valueFormatter: function(value) {
                return value;
              }
            },
            // data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
            data: concreat
          }
        ]
      });
    },
    getTypesSettlement(supplyConc) {
      console.log(supplyConc, "supplyConc");
      const myChart = echarts.init(this.$refs.typesSettlementId);
      myChart.setOption({
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            // params 是一个包含当前数据信息的数组
            console.log(params);
            let result = "";
            // params.forEach(function (item) {
            //   const seriesName = item.seriesName; // 系列名称
            //   const value = item.value; // 数据值
            result = `${params.data.name}(万元): ${params.data.value}<br/>`;
            // });
            return result;
          }
        },
        legend: {
          top: "0%",
          left: "center",
          icon: "circle"
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: ["30%", "60%"],
            center: ["50%", "50%"],
            label: {
              show: true,
              color: "#4A4A4A", // 设置字体颜色为红色
              // 其他标签样式设置
              normal: {
                show: true,
                position: "outside", // 标签显示在外部
                formatter: "{b}", // 自定义标签的格式
                color: "#4A4A4A",
                minMargin: 5 // 设置最小边距，确保标签可见
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 10, // 设置线长度
                length2: 10, // 设置文字到图形边界的距离
                smooth: 0.2 // 线的平滑度
              }
            },
            data: supplyConc,
            itemStyle: {
              normal: {
                color: function(params) {
                  // 定制颜色，params.dataIndex为当前数据项的索引
                  var colorList = ["#F45C5C", "#AF67E7", "#FFCF2A"];
                  return colorList[params.dataIndex % colorList.length];
                }
              }
            }
          }
        ]
      });
    },
    getMonthlyDisposalAmount(loopConc) {
      let yearOne = Object.keys(loopConc)[0],
        yearTwo = Object.keys(loopConc)[1],
        dataOne = Object.values(loopConc)[0],
        dataTwo = Object.values(loopConc)[1];
      console.log(yearOne, yearTwo, dataOne, dataTwo, "loopConc");
      const myChart = echarts.init(this.$refs.monthlyDisposalAmountId);
      myChart.setOption({
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            // console.log(params,'params')
            let result = "";
            params.forEach(function(item, index) {
              item.value = item.value == undefined ? 0 : item.value;
              const seriesName = item.seriesName + "(万元)"; // 系列名称
              const value = item.value; // 数据值
              // 按照你想要的格式拼接字符串
              result += `${item.name}<br/>${seriesName}: ${value}<br/>`;
            });
            return result;
          }
        },
        legend: {
          data: [yearOne, yearTwo]
        },
        grid: {
          left: "6%",
          right: "8%",
          bottom: "13%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ],
          axisTick: {
            show: false // 确保刻度线显示
          },
          axisLine: {
            lineStyle: {
              color: "#DFDFDF"
            }
          },
          axisLabel: {
            color: "#4A4A4A",
            interval: 0 // 显示所有刻度值
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            lineStyle: {
              type: "dashed" // 设置为虚线
            }
          },
          axisTick: {
            show: false // 确保这里是 true
          },
          axisLine: {
            show: false // 这里设置为false隐藏y轴轴线
          }
        },
        series: [
          {
            name: yearOne,
            type: "line",
            stack: "Total",
            symbol: "circle", // 设置折线图中的标记形状为圆形
            symbolSize: 5, // 设置折线图中的标记大小
            smooth: true,
            data: dataOne,
            itemStyle: {
              normal: {
                color: "#4991FF", // 点的颜色
                lineStyle: {
                  color: "#4991FF" // 线的颜色
                }
              }
            }
          },
          {
            name: yearTwo,
            type: "line",
            stack: "Total",
            symbol: "circle", // 设置折线图中的标记形状为圆形
            symbolSize: 5, // 设置折线图中的标记大小
            smooth: true,
            data: dataTwo,
            itemStyle: {
              normal: {
                color: "#38B92B", // 点的颜色
                lineStyle: {
                  color: "#38B92B" // 线的颜色
                }
              }
            }
          }
        ]
      });
    }
  }
};
</script>

<style scoped lang="scss">
.board-echarts {
  display: flex;
  .content1 {
    width: 350px;
    height: 647px;
    background: #f5f8fb;
    border-radius: 12px;
    margin-left: 20px;
    padding: 10px;
    .data {
      .title {
        display: flex;
        .text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #4a4a4a;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          margin: 0 5px;
        }

        .line {
          border-top: 1px solid #bdbdbd; /* 设置顶部边框，可以调整宽度、样式和颜色 */
          height: 1px; /* 设置高度 */
          width: 38%; /* 设置宽度 */
          margin: 10px 0; /* 设置上下外边距，可以调整 */
        }
      }
      .list {
        .item {
          display: flex;
          height: 42px;
          margin-top: 24px;
          justify-content: space-between;
          .item-date {
            font-weight: 600;
            font-size: 14px;
            color: #888888;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            margin-right: 45px;
          }
          .item-price {
            .price-icon {
              font-size: 12px;
              color: #999999;
              line-height: 17px;
              text-align: left;
              font-style: normal;
            }
            font-weight: 600;
            font-size: 30px;
            color: #1970ff;
            line-height: 42px;
            text-align: right;
            font-style: normal;
          }
        }
      }
    }
    .border {
      border-top: 1px solid #ffffff; /* 设置顶部边框，可以调整宽度、样式和颜色 */
      width: 338px;
      height: 6px;
      background: #ffffff;
      margin: 10px 0; /* 设置上下外边距，可以调整 */
    }
    .echarts {
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #4a4a4a;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        margin: 18px 0 12px 0;
      }
    }
  }
  .content2 {
    width: 350px;
    height: 647px;
    background: #f5f8fb;
    border-radius: 12px;
    margin-left: 20px;
    padding: 10px;
    .data {
      .title {
        display: flex;
        .text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #4a4a4a;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          margin: 0 5px;
        }

        .line {
          border-top: 1px solid #bdbdbd; /* 设置顶部边框，可以调整宽度、样式和颜色 */
          height: 1px; /* 设置高度 */
          width: 38%; /* 设置宽度 */
          margin: 10px 0; /* 设置上下外边距，可以调整 */
        }
      }
      .list {
        .item {
          display: flex;
          height: 42px;
          margin-top: 24px;
          justify-content: space-between;
          .item-date {
            font-weight: 600;
            font-size: 14px;
            color: #888888;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            margin-right: 45px;
          }
          .item-price {
            .price-icon {
              font-size: 12px;
              color: #999999;
              line-height: 17px;
              text-align: left;
              font-style: normal;
            }
            font-weight: 600;
            font-size: 30px;
            color: #1970ff;
            line-height: 42px;
            text-align: right;
            font-style: normal;
          }
        }
      }
    }
    .border {
      border-top: 1px solid #ffffff; /* 设置顶部边框，可以调整宽度、样式和颜色 */
      width: 338px;
      height: 6px;
      background: #ffffff;
      margin: 10px 0; /* 设置上下外边距，可以调整 */
    }
    .echarts {
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #4a4a4a;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        margin: 18px 0 12px 0;
      }
    }
  }
  .content3 {
    width: 350px;
    height: 647px;
    background: #f5f8fb;
    border-radius: 12px;
    margin-left: 20px;
    padding: 10px;
    .data {
      .title {
        display: flex;
        .text {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #4a4a4a;
          line-height: 25px;
          text-align: left;
          font-style: normal;
          margin: 0 5px;
        }

        .line {
          border-top: 1px solid #bdbdbd; /* 设置顶部边框，可以调整宽度、样式和颜色 */
          height: 1px; /* 设置高度 */
          width: 38%; /* 设置宽度 */
          margin: 10px 0; /* 设置上下外边距，可以调整 */
        }
      }
      .list {
        .item {
          display: flex;
          height: 42px;
          margin-top: 24px;
          justify-content: space-between;
          .item-date {
            font-weight: 600;
            font-size: 14px;
            color: #888888;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            margin-right: 45px;
          }
          .item-price {
            .price-icon {
              font-size: 12px;
              color: #999999;
              line-height: 17px;
              text-align: left;
              font-style: normal;
            }
            font-weight: 600;
            font-size: 30px;
            color: #1970ff;
            line-height: 42px;
            text-align: right;
            font-style: normal;
          }
        }
      }
    }
    .border {
      border-top: 1px solid #ffffff; /* 设置顶部边框，可以调整宽度、样式和颜色 */
      width: 338px;
      height: 6px;
      background: #ffffff;
      margin: 10px 0; /* 设置上下外边距，可以调整 */
    }
    .echarts {
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #4a4a4a;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        margin: 18px 0 12px 0;
      }
    }
  }
}
</style>
